import { render, staticRenderFns } from "./question_reply.vue?vue&type=template&id=60a35d2f&scoped=true&"
import script from "./question_reply.vue?vue&type=script&lang=js&"
export * from "./question_reply.vue?vue&type=script&lang=js&"
import style0 from "./question_reply.vue?vue&type=style&index=0&id=60a35d2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a35d2f",
  null
  
)

export default component.exports